import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';

import * as moment from 'moment'

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
    
    readonly DT_FORMAT = 'YYYY-MM-DD';

    parse(value: string): NgbDateStruct {
        if (value) {
            value = value.trim();
            let mdt = moment(value, this.DT_FORMAT);
            return {
                year: mdt.year(),
                month: mdt.month() + 1,
                day: mdt.date(),
            };
        }
        return null;
    }

    format(date: NgbDateStruct): string {
        if (!date) return '';
        let mdt = moment([date.year, date.month - 1, date.day]);
        if (!mdt.isValid()) return '';
        return mdt.format(this.DT_FORMAT);
    }
    
}